import {
    ActionFunction,
    redirect
} from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { parseFormData } from "../../utils/parseFormData";


export const professionAction: ActionFunction = async ({ request, params }) => {
    const formData = await request.formData();
    const updates = parseFormData(formData);
    if (params.id === "new")
        await axiosApi.post("/api/professions", updates);
    else await axiosApi.put("/api/professions", { ...updates, professionCode: params.professionCode });
    return redirect(`/professions`);
}